'use strict';

(function ($) {
	var StickySecondaryNav;

	function make_page_full_height() {
		var $main = $('#main');
		var windowHeight = $(window).height();
		var $stage = $('#app-stage');
		var stageHeight = $stage.css('min-height', 0).outerHeight(); // need to get original height
		$stage.css('min-height', '100vh');
		var minHeight = windowHeight - (stageHeight - $main.outerHeight());

		$main.css({
			minHeight: minHeight
		});
	}

	$(document).ready(function () {
		var $body = $('body');

		// START Sticky and Desktop Converted Navs
		var HeaderNav = new Nav({
			source_id: 'menu-main-menu',
			target_wrapper_id: 'menu-main-desktop-wrapper',
			target_id: 'menu-main-desktop',
			toggle_class: 'stage-toggle',
			breakpoint: 992
		});

		var SocialNav = new Nav({
			source_id: 'menu-social',
			target_wrapper_id: 'menu-social-desktop-wrapper',
			target_id: 'menu-social-desktop',
			toggle_class: 'stage-toggle',
			breakpoint: 992
		});

		var SearchModal = new Modal('search-modal');

		var StickyHeader = new Sticky({
			id: 'site-header',
			stage: '.stage-shelf',
			type: 'sticky'
		});

		if ($('.scroll-form').length > 0) {
			new ScrollForm();
		}

		// make_page_full_height()

		$('.tours-slider').find('.owl-carousel').owlCarousel({
			dots: true,
			nav: false,
			loop: true,
			margin: 0,
			items: 1,
			animateOut: 'slideOutUp',
			animateIn: 'slideInUp',
			autoplay: true
		});

		$('.learn-slider').find('.owl-carousel').owlCarousel({
			nav: true,
			dots: false,
			center: true,
			loop: true,
			margin: 30,
			items: 2,
			navText: ['<i class="fas fa-chevron-left"></i>', '<i class="fas fa-chevron-right"></i>'],
			autoplay: true,
			startPosition: 1,
			responsive: {
				0: {
					items: 2
				},
				992: {
					items: 4
				},
				1200: {
					items: 5
				}
			}
		});

		$('.tour-media-slider').find('.owl-carousel').owlCarousel({
			dots: false,
			nav: true,
			items: 1,
			stagePadding: 10,
			margin: 5,
			loop: true,
			navText: ['<i class="fas fa-chevron-left"></i>', '<i class="fas fa-chevron-right"></i>'],
			responsive: {
				576: {
					stagePadding: 40,
					margin: 15
				},
				768: {
					stagePadding: 60,
					margin: 20
				}
			}
		});

		if (!window.matchMedia('(min-width: 1400px)').matches) {
			var $secondaryCollapseNav = $('.nav-secondary-items.collapse');

			$secondaryCollapseNav.find('.filter-option').on('click', function () {
				return $secondaryCollapseNav.collapse('hide');
			});
			$secondaryCollapseNav.find('a').on('click', function () {
				return $secondaryCollapseNav.collapse('hide');
			});
		}

		if ($('#nav-secondary').length > 0) {
			StickySecondaryNav = new Sticky({
				id: 'nav-secondary',
				parent: StickyHeader,
				type: 'fixed'
				// container: true,
			});
		}

		// START TABS - Active Fix (multiple tabs will be active... maybe something to do with each tab content section containing an owl carousel?)
		var nav_tabs = $('.nav-tabs');
		if (nav_tabs.length > 0) {
			$(nav_tabs).find('a').on('click', function () {
				var tab_id = $(this).attr('href').split('#')[1];
				$('#' + tab_id).siblings().removeClass('active');
			});
		}
		// END TABS - Active Fix

		// LoadMore for blog posts

		if ($body.hasClass('blog')) {
			new LoadMoreWP({
				initialCount: 11,
				loadCount: 8,
				wrapperSelector: '.posts-tertiary-wrapper'
			});
		} else if ($body.hasClass('category') || $body.hasClass('tag')) {
			var tax = void 0;
			if ($body.hasClass('category')) tax = 'category';
			if ($body.hasClass('tag')) tax = 'tag';

			var pattern = new RegExp('(' + tax + '-\\d.*\\d|' + tax + '-\\d)');
			var taxClass = $body.attr('class').match(pattern)[0];

			if (taxClass && taxClass.length > 0) {
				var taxID = parseInt(taxClass.split(tax + '-')[1]);
				new LoadMoreWP({
					initialCount: 11,
					loadCount: 8,
					wrapperSelector: '.posts-tertiary-wrapper',
					taxType: tax,
					taxID: taxID
				});
			}
		}
		// END LoadMore

		// START MailChimp Form mods
		var $formTourUpdates = $('.form-set-email-placeholder');

		if ($formTourUpdates.length > 0) {
			$formTourUpdates.find('input[type="email"]').attr('placeholder', 'Your e-mail');
		}
		// END MailChimp Form mods

		var $all_videos = $('iframe[src*="//player.vimeo.com"], iframe[src*="//www.youtube.com"]');
		$all_videos.wrap('<div class="video-container"></div>');

		CollapseX.collapseSiblings();
	}); // END document ready

	$(window).on('load', function () {
		// cross browser select styles
		setTimeout(function () {
			$('select').select2();

			var select_arrows = $('.select2-selection__arrow');
			for (var i = 0; i <= select_arrows.length; i += 1) {
				var $arrow = $(select_arrows[i]);
				if ($arrow) {
					$arrow.find('b').remove();
					$arrow.append('<img src="/wp-content/themes/johngreengo/assets/build/images/icon-angle-down.svg" alt="arrow down"/>');
				}
			}

			var $buttons_need_arrow = $('.btn-wrapper-add-arrow');
			if ($buttons_need_arrow.length > 0) $buttons_need_arrow.find('.nf-field-element').append('<i class="fa fa-angle-right"></i>');
		}, 0);
	});
})(jQuery);